import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { authClient } from "@/lib/auth/auth-client";
import { resolveRoleAccess } from "@/server/auth-access.functions";

export const Route = createFileRoute("/patient/dashboard")({
  component: PatientDashboardGate,
});

function PatientDashboardGate() {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await authClient.getSession();
      const user = data?.user;
      if (cancelled) return;
      if (!user) { navigate({ to: "/login/patient" }); return; }
      // Auto-provision patient access (any signed-in user can have patient portal).
      // resolveRoleAccess checks the user's roles server-side and inserts the
      // 'patient' role if missing — mirrors the old client check + insert.
      await resolveRoleAccess({ data: { role: "patient" } });
      if (cancelled) return;
      navigate({ to: "/dashboard/patient" });
    })();
    return () => { cancelled = true; };
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground gap-2">
      <Loader2 className="h-4 w-4 animate-spin" /> Loading patient portal…
    </div>
  );
}
